// extracted by mini-css-extract-plugin
export default {"TiltedCards":"TiltedCards_TiltedCards__aQKv2","cardLight":"TiltedCards_cardLight__FCU3b","cardDark":"TiltedCards_cardDark__lQE1O"};